import React, { useEffect, useRef, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons";

import Colors from "../../../Resources/Color";

const getScrollableNodeFromRef = (scrollContainerRef) => {
  const refCurrent = scrollContainerRef?.current;
  if (!refCurrent) {
    return null;
  }

  const scrollableNode = refCurrent.getScrollableNode?.();
  if (scrollableNode) {
    return scrollableNode;
  }

  if (refCurrent.scrollTop !== undefined) {
    return refCurrent;
  }

  const firstChild = refCurrent.children?.[0];
  if (firstChild && firstChild.scrollTop !== undefined) {
    return firstChild;
  }

  return null;
};

const CompetitionFederationSearchRow = ({
  federation,
  isSelected,
  isCurrentValue,
  showEnterHint,
  onSelect,
  onHover,
  index,
  totalResults,
  scrollContainerRef,
  keyboardNavigationRef,
}) => {
  const rowRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (
      !isSelected ||
      !keyboardNavigationRef?.current ||
      !rowRef.current ||
      !scrollContainerRef?.current
    ) {
      return;
    }

    const isFirstItem = index === 0;
    const isLastItem = index === totalResults - 1;
    const rowElement = rowRef.current;
    const scrollContainer = getScrollableNodeFromRef(scrollContainerRef);

    if (isFirstItem) {
      scrollContainerRef.current?.scrollTo?.({ y: 0, animated: true });
      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
      }
      return;
    }

    if (isLastItem) {
      scrollContainerRef.current?.scrollToEnd?.({ animated: true });
      if (scrollContainer) {
        const containerHeight = scrollContainer.clientHeight;
        const scrollHeight = scrollContainer.scrollHeight;
        scrollContainer.scrollTop = scrollHeight - containerHeight;
      }
      return;
    }

    rowElement.scrollIntoView?.({
      block: "nearest",
      behavior: "smooth",
    });
  }, [index, isSelected, keyboardNavigationRef, scrollContainerRef, totalResults]);

  return (
    <TouchableOpacity
      ref={rowRef}
      onPress={onSelect}
      onMouseEnter={() => {
        setIsHovered(true);
        onHover?.();
      }}
      onMouseLeave={() => setIsHovered(false)}
      activeOpacity={0.9}
      style={{
        minHeight: 38,
        borderRadius: 10,
        paddingHorizontal: 12,
        paddingVertical: 10,
        marginHorizontal: 4,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor:
          isSelected || isHovered ? Colors.hoveredGray : "transparent",
      }}
    >
      <Text
        style={{
          fontSize: 13,
          color: isCurrentValue ? Colors.bubbleColor : Colors.blackColor,
          fontWeight: isCurrentValue ? "600" : "400",
          flexShrink: 1,
        }}
        numberOfLines={1}
      >
        {federation}
      </Text>
      {(showEnterHint || isCurrentValue) && (
        <View
          style={{
            marginLeft: 8,
            minWidth: 16,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {showEnterHint ? (
            <MaterialCommunityIcons
              name="keyboard-return"
              size={12}
              color={Colors.grayColor}
            />
          ) : (
            <Ionicons name="checkmark" size={16} color={Colors.bubbleColor} />
          )}
        </View>
      )}
    </TouchableOpacity>
  );
};

export default CompetitionFederationSearchRow;
